import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

interface ConnectorIconPlaceholderProps {
	name: string;
	iconUrl?: string;
	size?: 16 | 20 | 24;
}

const styles = cssMap({
	iconImg16: {
		width: '16px',
		height: '16px',
		borderRadius: token('radius.xsmall'),
	},
	iconImg20: {
		width: '20px',
		height: '20px',
		borderRadius: token('radius.xsmall'),
	},
	iconImg24: {
		width: '24px',
		height: '24px',
		borderRadius: token('radius.xsmall'),
	},
	placeholder16: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: '16px',
		height: '16px',
		borderRadius: token('radius.xsmall'),
		backgroundColor: token('color.background.neutral'),
	},
	placeholder20: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: '20px',
		height: '20px',
		borderRadius: token('radius.xsmall'),
		backgroundColor: token('color.background.neutral'),
	},
	placeholder24: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: '24px',
		height: '24px',
		borderRadius: token('radius.xsmall'),
		backgroundColor: token('color.background.neutral'),
	},
});

const imgStyleMap = {
	16: styles.iconImg16,
	20: styles.iconImg20,
	24: styles.iconImg24,
} as const;

const placeholderStyleMap = {
	16: styles.placeholder16,
	20: styles.placeholder20,
	24: styles.placeholder24,
} as const;

/**
 * Renders a connector icon from iconUrl, or a letter-based placeholder if unavailable.
 * Replace with actual product logo components when available.
 */
export const ConnectorIconPlaceholder = ({
	name,
	iconUrl,
	size = 24,
}: ConnectorIconPlaceholderProps) => {
	if (iconUrl) {
		return <img src={iconUrl} alt="" css={imgStyleMap[size]} />;
	}

	return (
		<Box xcss={placeholderStyleMap[size]} role="img" aria-label={name}>
			<Text size="small" weight="semibold" color="color.text.subtle">
				{name.charAt(0).toUpperCase()}
			</Text>
		</Box>
	);
};
